// extracted by mini-css-extract-plugin
module.exports = {"app-footer":"bt_fd","appFooter":"bt_fd","logo":"bt_d3","sub-footer":"bt_ff","subFooter":"bt_ff","links":"bt_fg","copy":"bt_fh"};